import { render, staticRenderFns } from "./custom-form-group.vue?vue&type=template&id=30685fbe&scoped=true&"
import script from "./custom-form-group.vue?vue&type=script&lang=js&"
export * from "./custom-form-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30685fbe",
  null
  
)

export default component.exports